var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"feedback-form"}},[_c('p',[_vm._v("OK, if you would like to add any additional information you can do so below, or otherwise just click to submit your feedback")]),_vm._v(" "),_c('EmailFormInput'),_vm._v(" "),_c('SubmitButton',{attrs:{"btnText":"Send Feedback"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0424774a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedbackForm.vue
// module id = 117
// module chunks = 0